import React from 'react';

/**
 * WCAG 2.4.1 — first focusable control should skip repetitive navigation.
 */
const SkipToMain = () => (
  <a href="#main-content" className="skip-to-main">
    Skip to main content
  </a>
);

export default SkipToMain;
